import React from "react";
import {
  Autocomplete,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useGetAgentsQuery } from "../../../redux/api/agentsApi";

const AgentSelect = ({ value, onChange, agencyId, ...props }) => {
  const { data: agents, isLoading, isError } = useGetAgentsQuery(agencyId, {
    skip: !agencyId,
  });

  // ✅ Ensure we always work with an array
  const safeAgents = Array.isArray(agents) ? agents : [];

  // ✅ Only include active agents (status === 1)
  const activeAgents = safeAgents.filter((agent) => agent.status === 1);

  // ✅ Find the currently selected agent
  const selectedAgent = activeAgents.find((a) => a.agentid === value) || null;

  return (
    <Autocomplete
      fullWidth
      size="small"
      // ✅ Must be an array — not an object
      options={activeAgents}
      value={selectedAgent}
      onChange={(_, newValue) =>
        onChange({
          target: {
            name: "AgentId",
            value: newValue ? newValue.agentid : "",
          },
        })
      }
      getOptionLabel={(option) =>
        option
          ? `${option.firstName} ${option.lastName} — ${option.roleName}`
          : ""
      }
      loading={isLoading}
      disabled={!agencyId || isError}
      noOptionsText={
        isError ? "Error loading agents" : "No Active Agents Found"
      }
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select Agent"
          variant="outlined"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {isLoading ? <CircularProgress size={18} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          {...props}
        />
      )}
    />
  );
};

export default AgentSelect;
